import React, { useEffect, useState } from "react";
import {
    Construction,
    Wrench,
    Forklift,
    Truck,
    Zap,
    Layers,
    HardHat,
    Cog,
    ScanSearch,
    Sparkles,
    Hammer,
    ArrowRight,
} from "lucide-react";
import { getCategories } from "../lib/api";

const ICON_MAP = {
    Construction,
    Wrench,
    Forklift,
    Truck,
    Zap,
    Layers,
    HardHat,
    Cog,
    ScanSearch,
    Sparkles,
    Hammer,
};

export const Categories = ({ onSelect }) => {
    const [cats, setCats] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getCategories()
            .then((d) => setCats(d.categories || []))
            .catch(() => setCats([]))
            .finally(() => setLoading(false));
    }, []);

    return (
        <section
            id="categories"
            data-testid="categories-section"
            className="relative bg-white py-16 lg:py-24"
        >
            <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-14">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-10">
                    <div className="max-w-2xl">
                        <div className="text-[11px] font-bold uppercase tracking-[0.3em] text-nsp-green mb-4">
                            Catalogo Attrezzature
                        </div>
                        <h2
                            data-testid="categories-title"
                            className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase leading-[1] text-nsp-green tracking-tight"
                        >
                            Tutto ciò che serve
                            <br />
                            <span className="text-nsp-yellow-dark">al tuo cantiere.</span>
                        </h2>
                    </div>
                    <p className="text-gray-500 max-w-md text-base">
                        11 categorie e oltre 60 modelli professionali. Scegli ciò che ti
                        serve e calcola il preventivo in pochi click.
                    </p>
                </div>

                {loading ? (
                    <div className="text-gray-400 text-sm">Caricamento categorie...</div>
                ) : (
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4">
                        {cats.map((c, idx) => {
                            const Icon = ICON_MAP[c.icon] || Wrench;
                            return (
                                <button
                                    key={c.id}
                                    data-testid={`category-card-${c.id}`}
                                    onClick={() => onSelect && onSelect(c.id)}
                                    className="group relative bg-white border border-gray-100 rounded-3xl p-5 md:p-6 text-left hover:border-nsp-green hover:-translate-y-1 hover:shadow-xl hover:shadow-nsp-green/10 transition-all duration-300 overflow-hidden"
                                >
                                    <div className="absolute top-0 right-0 text-[90px] font-display text-nsp-green/[0.03] group-hover:text-nsp-green/[0.06] leading-none select-none">
                                        {String(idx + 1).padStart(2, "0")}
                                    </div>
                                    <div className="w-11 h-11 rounded-2xl bg-nsp-green-50 group-hover:bg-nsp-green flex items-center justify-center mb-5 transition-colors relative z-10">
                                        <Icon
                                            className="w-5 h-5 text-nsp-green group-hover:text-nsp-yellow transition-colors"
                                            strokeWidth={2.2}
                                        />
                                    </div>
                                    <div className="font-bold text-nsp-green text-sm uppercase tracking-wide leading-tight relative z-10">
                                        {c.name}
                                    </div>
                                    <div className="text-gray-400 text-xs mt-1.5 relative z-10">
                                        {c.product_count} prodotti
                                    </div>
                                    <ArrowRight className="absolute bottom-4 right-4 w-4 h-4 text-gray-300 group-hover:text-nsp-green group-hover:translate-x-1 transition-all" />
                                </button>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

export default Categories;
